<template>
  <div>
    <header :class="{enable:isHome,scrollDown:isScrollDown}">
      <div>
        <router-link to="/" class="pc-logo"><img src="@img/logo.png" alt=""></router-link>
        <router-link to="/" class="mobile-logo"><img src="@img/mobile/logo.png" alt=""></router-link>
        <ul class="nav clearfix" :class="{'_open':isNavOpen}">
          <template v-for="(nav, index) in menus">
            <li v-if="nav.child" :class="{'enable':isNavSubList === nav.subtitle}" :key="index">
              <a href="javascript:void(0);" class="hassub" @click.prevent="navSubList(nav.subtitle)">
                <span v-html="$t(nav.title)"></span>
                <i :class="isNavSubList ? 'icon-less' : 'icon-plus'"></i>
              </a>
              <div>
                <template v-for="(childs, idx) in nav.child">
                  <router-link :to="childs.link" :key="idx"><i>▲</i><span v-html="$t(childs.title)"></span></router-link>
                </template>
              </div>
            </li>
            <li v-else-if="index === 2" :key="index">
              <a href="https://r88games.com/" target="_blank">
                <span v-html="$t(nav.title)"></span>
              </a>
            </li>
            <li v-else-if="index === 4" :key="index">
              <a href="https://www.rollingbet.com/#/platform/game" target="_blank">
                <span v-html="$t(nav.title)"></span>
              </a>
            </li>
            <li v-else :key="index"><router-link :to="nav.link" v-html="$t(nav.title)"></router-link></li>
          </template>
        </ul>
        <div 
          class="lang"
          :class="{'active':isLangToggle}"
          @click="langToggle"
        >
          <span class="lang_n" :rel="`lang_${signalChange}`">{{langxTitle()}}</span>
          <ul>
              <li v-for="(list,index) in langxList" :key="index" :rel="`lang_${list.lang_code}`" @click="chgLang(`${list.lang_code}`)">{{langxTitle(`${list.lang_code}`)}}</li>
          </ul>
          <select name="" id="" class="langselect" v-model="langxChange">
            <option v-for="(list,index) in langxList" :key="index" :value="`${list.lang_code}`">{{list.lang_name}}</option>
          </select>
        </div>
        <span class="hamburger" :class="{'active':isNavOpen}" @click="navToggle" v-if="deviceModel==='mb'"><i></i></span>
      </div>
    </header>
    <div class="gotop">
      <ul>
        <!-- <li>
          <i class="icon-27"></i>
          {{$t('lang_men_gameConnection')}} sales@rollingbet.com
        </li>
        <li>
            <i class="icon-28"></i>
            {{$t('lang_men_technicalSupport')}} info@rollingbet.com
          </li> -->
        <li>
            <i class="icon-telegram"></i>
            Telegram：@RollingbetOfficial
          </li>
      </ul>
      <span @click="gotop">
        <i class="icon-32"></i>
        TOP
      </span>
    </div>
    <div class="loading" :class="{'enable':isLoadingShow}">
      <section>
        <div class="sk-folding-cube">
          <div class="sk-cube1 sk-cube"></div>
          <div class="sk-cube2 sk-cube"></div>
          <div class="sk-cube4 sk-cube"></div>
          <div class="sk-cube3 sk-cube"></div>
        </div>
        <b>Loading...</b>
      </section>
    </div>
    <statement></statement>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
/** data */
import navData from '@data/header.json'
/** components */
import statement from '@/components/layout/Statement'

export default {
  name: 'Header',
  components: {
    statement,
  },
  data() {
    return {
      isHome: true,
      isScrollDown: false,
      nowPage: '',
      isLangToggle: false,
      isNavOpen: false,
      isNavSubList: '',
      langxChange: 'hk',
      menus: [],
      deviceModel: 'pc',
    }
  },
  methods: {
    setLang(lang) {
      if (this.signalChange !== lang) {
        this.$store.dispatch('setLang', lang)
      }
    },
    pageName() {
      const $this = this
      switch ($this.$route.name) {
        case 'home':
        case 'G2EAsia2017':
          $this.isHome = true
          break
        default:
          $this.isHome = false
      }
    },
    scrollWatch() {
      const $this = this
      $(window).scroll(function() {
        $this.isScrollDown =
          $(window).scrollTop() > $('header').outerHeight() ? true : false
      })
    },
    scrollInit() {
      if (this.$route.name !== this.nowPage) {
        $('html,body').scrollTop(0)
        this.nowPage = this.$route.name
      }
    },
    langToggle() {
      if ($(window).width() < 997) {
        return
      }
      this.isLangToggle = this.isLangToggle ? false : true
    },
    navSubList(value) {
      this.isNavSubList = this.isNavSubList !== value ? value : ''
    },
    chgLang(lang) {
      this.setLang(lang)
      this.$cookie.delete('rollingbet')
      this.$cookie.set('rollingbet', lang, 3)
    },
    langxTitle: function(str) {
      const lang = str || this.signalChange
      switch (lang) {
        case 'hk':
          return '繁'
        case 'cn':
          return '簡'
        case 'en':
          return 'ENG'
        case 'jp':
          return 'JP'
        case 'kr':
          return 'KR'
        case 'th':
          return 'TH'
        case 'vn':
          return 'VN'
      }
    },
    navToggle: function(value) {
      this.isNavOpen = value === 'close' ? false : this.isNavOpen ? false : true
      if (!this.isLangToggle) {
        this.navSubList('')
      }
    },
    gotop() {
      $('body,html').animate({ scrollTop: 0 }, 300)
    },
    getDevice: function() {
      window.addEventListener('resize', this.windowResHead)
    },
    windowResHead: function() {
      const $this = this
      if ($this.deviceModel === 'mb' && $(window).width() > 996) {
        $this.isLangToggle = false
        $this.deviceModel = 'pc'
      } else if ($this.deviceModel === 'pc' && $(window).width() <= 996) {
        $this.isLangToggle = false
        $this.deviceModel = 'mb'
      }
    },
  },
  watch: {
    langxChange() {
      this.chgLang(this.langxChange)
    },
    $route() {
      this.scrollInit()
      this.pageName()
      this.navSubList('')
      this.navToggle('close')
    },
  },
  computed: {
    ...mapGetters({
      signalChange: 'nowLangx',
      langxList: 'langxList',
      isLoadingShow: 'loadingState',
    }),
  },
  mounted() {
    this.scrollInit()
    this.pageName()
    this.scrollWatch()
    this.langxTitle()
    this.menus = navData
    this.langxChange = this.signalChange
    this.getDevice()
    this.windowResHead()
  },
}
</script>
